<template>
  <ModalCard v-if="isOpenModal === true" :title="title" :handle-close="onStay">
    <template #body>
      <div>
        <slot name="body">
          <p>
            This page is asking you to confirm that you want to leave —
            information you’ve entered may not be saved.
          </p>
        </slot>
      </div>
    </template>
    <template #footer>
      <div
        class="is-flex is-align-items-center is-justify-content-space-between"
        style="width: 100%"
      >
        <slot name="footer" :on-done="onDone" :nav-next="navNext">
          <button
            class="button is-small is-danger"
            @click="
              () => {
                onDone()
                navNext()
              }
            "
          >
            Leave
          </button>
          <button class="button is-primary is-small" @click="onStay">
            Stay
          </button>
        </slot>
      </div>
    </template>
  </ModalCard>
</template>

<script>
export default {
  emits: ['update:open'],
  props: {
    navNext: { type: Function, default: null },
    navCancel: { type: Function, default: null },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: 'Unsaved changes' },
    open: { type: Boolean, default: null },
  },
  data() {
    return {
      isOpenModal: false,
    }
  },
  methods: {
    navGuardEvent(ev) {
      if (this.disabled) return
      if (!this.navNext) return
      ev.preventDefault()
      ev.returnValue = ''
    },
    onDone() {
      this.isOpenModal = false
    },
    onStay() {
      this.isOpenModal = false
      if (this.navCancel) this.navCancel()
    },
  },
  watch: {
    open(val) {
      if (val !== null && val !== this.isOpenModal) this.isOpenModal = val
    },
    isOpenModal(val) {
      if (this.open !== null) this.$emit('update:open', val)
    },
    navNext: function (_next) {
      if (this.disabled) {
        // is this realy usefull tho ?
        _next()
      } else {
        this.isOpenModal = true
      }
    },
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.navGuardEvent)
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.navGuardEvent)
  },
}
</script>
